import * as React from 'react';
import { Controller, Toolbar, MainMenu } from '@tencent/workbench';
import { MoveItemFeature } from './move-item-feature';
import { TOOLBAR_ITEMS, MENU_CONFIGS, config } from './config';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';

@Controller({
    toolbarItems: TOOLBAR_ITEMS,
    menuItems: MENU_CONFIGS,
})
export class MoveItemController {
    constructor(private readonly feature: MoveItemFeature) {
    }

    @Toolbar(config.id, 'dropdownContent')
    @Toolbar(wrapIdForBig(config.id), 'dropdownContent')
    public insertDropdown() {
        return <MainMenu align="left" name={config.id} mode="menu" itemStyle={{ width: 166 }} />;
    }
}
